import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-58e239f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"TumiLogin\" data-v-58e239f2><div class=\"TumiForm\" data-v-58e239f2><div data-v-58e239f2><img src=\"" + _imports_0 + "\" alt=\"LogoTumi\" class=\"TumiLogoLola\" data-v-58e239f2><div class=\"mt-4\" data-v-58e239f2><p class=\"text-white mb-4\" data-v-58e239f2>Your email has been confirmed. Thank you.</p></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}